import React from 'react'
import _ from 'lodash'

import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'

import { renderDatasheetFields } from '../Fields'

import Hidden from '@material-ui/core/Hidden'

const styles = {
    root: {},
    table: {},
    thead : {
        '& tr th' : {
            color: '#019EAC',
            fontSize: '0.85rem',
            fontWeight: 600,
            borderBottom : 'none',
            backgroundColor : '#EFEEEF',
        }
    },
    tbody : {
        '& tr td' : {
            color : '#676767',
            fontSize: '0.85rem',
        },
        '& tr td:first-child' : {
            fontWeight: 500,
        }
    }
}

export const DatasheetField = withStyles(styles)((props) => {
    const { schema, record, classes } = props
    const certification = !!_.get(schema, "properties.ESTADO_CERTIFICACION", null)

    return (
        <Paper className={classes.root}>
            <Hidden xsDown>
                <Table className={classes.table}>
                    <TableHead className={classes.thead}>
                        <TableRow>
                            <TableCell align="center">Dato Técnico</TableCell>
                            <TableCell align="center">Valor</TableCell>
                            {certification && <TableCell align="center">Estado Certificación</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody className={classes.tbody} >
                        {renderDatasheetFields(schema, record.datasheet)}
                    </TableBody>
                </Table>
            </Hidden>
            <Hidden mdUp>
                {renderDatasheetFields(schema, record.datasheet)}
            </Hidden>
        </Paper>
    )
})
